/*
 * @Author: xg
 * @Date: 2020-06-03 14:05
 * @LastEditTime: 2020-06-03 14:05
 * @LastEditors: xg
 * @Description:
 */
/**
 * Author:XCL
 *
 * Time:2015-12-23
 */
'use strict';
angular.module('editcenterNewMediaPreviewRouterModule', []).config([
    '$stateProvider',
    function ($stateProvider) {
        $stateProvider.state('newMediaPreview', {
            // mediatype 渠道类型
            // metadataid 文章ID
            // isawaitrevise--待修订
            // versionid 版本id
            url: '/newmediapreview?mediatype&metadataid&isawaitrevise&versionid&fromsearch&account', // account 头条号独有
            views: {
                '': {
                    templateUrl: './editingCenter/newMediaPreview/newMediaPreview.html',
                    controller: 'editCenterNewMediaPreviewCtrl',
                },
            },
        });
    },
]);
